import { call, put, select, takeEvery } from 'redux-saga/effects';
import { types } from '@actions/transcript';
import { types as conferenceTypes } from '@actions/conference';
import { changeSpeakerNamesInTranscript } from '@services/transcriptEntryResource';

import { tokenSelector } from '@selectors/authentication';

export function* changeSpeakerNamesSaga(action) {
  try {
    const { speakers, transcriptId } = action;
    const token = yield select(tokenSelector);
    yield call(changeSpeakerNamesInTranscript, { transcriptId, speakers }, token);
    yield put({
      type: types.CHANGE_SPEAKER_NAMES.SUCCESS,
    });
    yield put({
      type: conferenceTypes.GET_TRANSCRIPT_ENTRY_BY_ID,
      id: transcriptId,
    });
  } catch (err) {
    yield put({
      type: types.CHANGE_SPEAKER_NAMES.FAILURE,
      message: err.message || 'Error when changing speaker names',
      errors: err.errors,
    });
  }
}

export default function* transcriptUpsert() {
  yield takeEvery(types.CHANGE_SPEAKER_NAMES.STARTED, changeSpeakerNamesSaga);
}



// WEBPACK FOOTER //
// ./redux/sagas/transcript/changeSpeakerNames.js